export default "__VITE_ASSET__0a663d03__"